module.exports = __webpack_public_path__ + "static/media/image030.a60ebd6f.jpg";